module.exports = __webpack_public_path__ + "img/Netherlands Antilles.3d46d59e.svg";